<template>
    <InputGroup>
        <IconField class="gold-exchange-phone-input">
            <InputIcon v-if="props.icon">
                <icon-phone-call :fill="true" />
            </InputIcon>
            <MyInputNumber
                v-model="number"
                :digits="0"
                @change="numberChanged"
                nullable
                :size="props.size"
                :error="props.invalid"
            />
<!--            <InputNumber v-model="number" name="phone" inputId="withoutgrouping" :use-grouping="false"-->
<!--                         input-class="ps-10" :size="props.size"-->
<!--                         fluid inputClass="ps-10" style="position: unset;" @input="numberChanged"-->
<!--                         :invalid="props.invalid" />-->
        </IconField>

        <Select v-model="selectedCountry" :options="countries" filter
                optionLabel="name_ar" placeholder="الدولة" @change="countryChanged"
                style="flex: 0 0 7rem" :size="props.size" autoFilterFocus :invalid="props.invalid">
            <template #value="slotProps">
                <div v-if="slotProps.value" class="flex items-center">
                    <div dir="ltr">{{ slotProps.value.phone_prefix }}</div>
                    <span class="mr-2" style="width: 18px">{{ slotProps.value.flag }}</span>
                </div>
                <span v-else>
                    {{ slotProps.placeholder }}
                </span>
            </template>
            <template #option="slotProps">
                <div class="flex items-center">
                    <span class="mr-2" style="width: 18px">{{ slotProps.option.flag }}</span>
                    <div>{{ slotProps.option.name_ar }}</div>
                </div>
            </template>
        </Select>
    </InputGroup>
</template>

<script setup>

    import { ref, defineProps, defineModel, onUpdated, watch } from 'vue';
    import IconMail from '@/components/icon/icon-mail.vue';
    import IconPhoneCall from '@/components/icon/icon-phone-call.vue';
    import MyInputNumber from '@/views/components/MyInputNumber.vue';

    const props = defineProps({
        countries: Array,
        defaultCountry: Object,
        size: { type: String, default: '' },
        icon: Boolean,
        invalid: Boolean
    });

    const phoneValue = defineModel();

    const selectedCountry = ref(props.defaultCountry);
    const number = ref(phoneValue.value ? Number(phoneValue.value?.split(' ')[1] || phoneValue.value) : null);

    const numberChanged = (value) => {
        phoneValue.value = selectedCountry.value?.phone_prefix + ' ' + String(value);
    };

    const isCountryChanged = ref(false);
    const countryChanged = (value) => {
        phoneValue.value = value.value.phone_prefix + ' ' + number.value;
        isCountryChanged.value = true;
    };

    watch(() => props.defaultCountry, (nv) => {
        if (!isCountryChanged.value) {
            selectedCountry.value = nv;
        }
    });
</script>

<style>
    .gold-exchange-phone-input input {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
</style>
